export default function (ctx) {
  // only run this middleware on the client side if they are logged in
  if (process.env.NODE_ENV !== 'development') {
    return
  }

  ctx.app.$auth.redirect('/')
}
